var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _c(
        "vue-content-loading",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { width: 988, height: 323 },
        },
        [
          _c("rect", {
            attrs: {
              x: "38",
              y: "83",
              rx: "5",
              ry: "5",
              width: "925.52",
              height: "223.07",
            },
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "41.84",
              y: "52.67",
              rx: "0",
              ry: "0",
              width: "152",
              height: "19.25",
            },
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "253.84",
              y: "357.67",
              rx: "0",
              ry: "0",
              width: "0",
              height: "0",
            },
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "211.84",
              y: "52.67",
              rx: "0",
              ry: "0",
              width: "152",
              height: "19.25",
            },
          }),
          _vm._v(" "),
          _c("rect", {
            attrs: {
              x: "380.84",
              y: "51.67",
              rx: "0",
              ry: "0",
              width: "152",
              height: "19.25",
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading",
            },
          ],
          staticClass: "card mortgage",
          attrs: { id: "actions-pane-container" },
        },
        [
          _c("div", [
            _c(
              "div",
              { staticClass: "nav-tabs-wrapper bb-0 mt-4 mt-xl-0" },
              [
                _c("scrollable-container", [
                  _c(
                    "ul",
                    { staticClass: "nav nav-tabs" },
                    _vm._l(_vm.tabs, function (ref) {
                      var name = ref.name
                      var label = ref.label
                      return _c(
                        "li",
                        {
                          key: name,
                          staticClass: "nav-item",
                          class: _vm.activeItem(name) ? "nav-item-active" : "",
                          on: {
                            click: function ($event) {
                              return _vm.setCurrentTab(name)
                            },
                          },
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass:
                                "nav-link grey-text text-darken-3 clickable",
                            },
                            [_vm._v(_vm._s(label))]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.collapsed
              ? _c(
                  "div",
                  {
                    staticClass:
                      "clickable py-1 px-2 text-light-gray close-action",
                    on: { click: _vm.toggleCollapse },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-times",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "action-pane-tabs-container" } },
            [
              !_vm.collapsed
                ? _c(
                    "div",
                    {
                      staticClass: "text-grey clickable pre-selected-area mt-2",
                      on: { click: _vm.toggleCollapse },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.$t("global.actions.clickHereTo", {
                              item: _vm.getCollapseText(),
                            })
                          ) +
                          "...\n      "
                      ),
                    ]
                  )
                : _c(_vm.currentTab + "-tab", {
                    key: _vm.currentTab,
                    tag: "component",
                    attrs: {
                      "tab-data": _vm.selectedTabData,
                      profile: _vm.profile,
                      "current-tab": _vm.currentTab,
                      "client-profile-id": _vm.clientProfileId,
                      username: _vm.username,
                      applications: _vm.applications,
                      "board-id": _vm.boardId,
                    },
                    on: {
                      "clear-data": _vm.clearData,
                      submit: _vm.handleSubmit,
                    },
                  }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }